<div class="wrapper mb-5">
    <div class="row align-items-center m-0" style="padding: 10px;">
        <img class="p-2" src="./assets/icons/arrow.svg">
        <span class="label-title ml-2 mr-3">Histório de créditos</span>
    </div>
    <div class="component-box container-fluid">
        <div class="container-fluid pt-4">
            <div class="row">
                <div class="col-md-6 col-sm-12">
                    <ul class="options-cadastro pl-0 float-left">
                        <li>
                            <div (click)="exportExtractExcel()" class="list-select ml-2 my-1">
                                <button _ngcontent-khv-c20="" class="list-select"  type="button">
                                    <span>Exportar Excel</span>
                                </button>
                            </div>
                        </li>
                        <li>
                            <div (click)="exportExtractPdf()" class="list-select ml-2 my-1">
                                <button _ngcontent-khv-c20="" class="list-select"  type="button">
                                    <span>Exportar PDF</span>
                                </button>
                            </div>
                        </li>
                    </ul>
                </div>
                <div class="col-md-6 col-sm-12 text-right">
                    <ul class="options-cadastro">
                        <li>
                            <div *ngIf="filtroOn" (click)="deleteFilter()" class="list-select ml-2
                                my-1">
                                <button class="list-select-delete" type="button">
                                    Apagar filtro
                                </button>
                            </div>
                        </li>
                        <li>
                            <div (click)="showFilter(modalfiltro)" class="list-select ml-2 my-1">
                                <button class="list-select"  type="button">
                                    <span><img src="assets/icons/filter.svg" style="height: 15px;"> Aplicar filtro</span>
                                    <!-- <span *ngIf="filtroOn"><img src="assets/icons/filter-purple.svg" style="height: 15px;"> Alterar filtro</span> -->
                                </button>
                            </div>
                        </li>
                        <li>
                            <div class="list-filter-show-item ml-2 my-1">
                                Mostrar:
                                <select (change)="showItemChanged($event.target.value)" class="ng-untouched ng-pristine ng-valid">
                                    <option _ selected="" value="10">10</option>
                                    <option value="25">25</option>
                                    <option value="50">50</option>
                                    <option value="100">100</option>
                                </select>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>

            <span  class="d-flex justify-content-end clean-modal-text my-2" style="font-size:small;">Data da consulta: {{ queryDate | date: "dd/MM/yyyy HH:mm:ss" }}</span>

            <div class="row">
                <div class="col-12">
                    <ul class="options-cadastro pl-0 float-left">
                        <li class="mr-3"><b>Data inicio: </b>{{ filtro.dateStart | date: "dd/MM/yyyy"}}</li>
                        <li class="mr-3"><b>Data fim: </b>{{ filtro.dateEnd | date: "dd/MM/yyyy"}}</li>
                        <li class="mr-3" *ngIf="filtroOn && filtro.type"><b>Tipo: </b>{{ filtro.type }}</li>
                        <li class="mr-3" *ngIf="filtroOn && filtro.stauts"><b>Stauts: </b>{{ filtro.stauts }}</li>
                        <li class="mr-3" *ngIf="filtroOn && filtro.value"><b>Valor: </b>{{ filtro.value | currency: 'BRL' }}</li>
                        <li class="mr-3" *ngIf="filtroOn && filtro.purchaseId"><b>Cód. Recarga: </b>{{ filtro.purchaseId }}</li>
                    </ul>
                </div>
            </div>   

            <div class="table-overflow">
                <div class="table-responsive visible-table">
                    <table class="list-table table table-striped" id="dataTable" width="100%" cellspacing="0">
                        <thead>
                            <th>Código</th>
                            <th>Referência</th>
                            <th>Cód. Recarga</th>
                            <th>Tipo</th>
                            <th>Status</th>
                            <th>Valor</th>
                            <th>Emissão</th>
                            <th>Vencimento</th>
                            <th>Processamento</th>
                            <th>Cancelamento</th>
                            <th></th>
                        </thead>
                        <tbody class="list-table-row">
                            <tr *ngFor=" let item of creditos | paginate : { itemsPerPage: showItem, currentPage: currentPage, totalItems: totalItems, id: 'creditHistory' }">
                                <td>{{ item.depositId }}</td>
                                <td>
                                    <span *ngIf='item.reference'>{{item.reference}}</span>
                                    <span *ngIf='!item.reference'>-</span>
                                </td>
                                <td>
                                    <span *ngIf='item.purchaseId'>{{ item.purchaseId  }}</span>
                                    <span *ngIf='!item.purchaseId'>-</span>
                                </td>
                                <td>{{ item.paymentType  }}</td>
                                <td>{{ item.status  }}</td>
                                <td>
                                    <span>R$</span><span style="float: right; clear: both">{{ item.value | currency: '' }}</span>
                                </td>
                                <td>
                                    <span *ngIf='item.release'>{{ item.release | date: "dd/MM/yyyy HH:mm" }}</span>
                                    <span *ngIf='!item.release'>-</span>
                                </td>
                                <td>
                                    <span *ngIf='item.due'>{{ item.due | date: "dd/MM/yyyy" }}</span>
                                    <span *ngIf='!item.due'>-</span>

                                </td>
                                <td>
                                    <span *ngIf='item.processing'>{{ item.processing | date: "dd/MM/yyyy HH:mm" }}</span>
                                    <span *ngIf='!item.processing'>-</span>

                                </td>
                                <td>
                                    <span *ngIf='item.cancellation'>{{ item.cancellation | date: "dd/MM/yyyy" }}</span>
                                    <span *ngIf='!item.cancellation'>-</span>
                                </td>
                                <td>
                                    <button *ngIf="item.status=='Concluído'"class="dropdown-button" (click)="showVisualizarReciboIntencaoDeposito(visualizarRecibo,item.depositGuid)">
                                        <img src="assets/icons/contrato.png" data-bs-toggle="tooltip" title="Ver recibo"/>
                                    </button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    
                    <div *ngIf="!creditos || creditos == [] || creditos.length == 0" class="text-center">
                        Nenhum registro carregado. Aplique o filtro para carregar a lista
                    </div>

                    <div class="page-custom mt-2">
                        <pagination-controls id="creditHistory" (pageChange)="carregarRelatorio($event)" responsive="true" previousLabel="" nextLabel=""></pagination-controls>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<!--Modal do Filtro-->
<ng-template #modalfiltro let-modal>
    <div class="col-12 modal-header clean-modal-header">
        <div class="col-md-12">
            <h5 class="clean-modal-title">Aplicar filtro</h5>
        </div>
    </div>
    <div class="row col-12 clean-modal-content">
        <div class="col-lg-4 col-md-6 col-sm-12 my-4">
            <div class="custom-filter-input-container">
                <mat-form-field>
                    <input id="startDate" matInput [matDatepicker]="startDate" placeholder="Data Início" [value]="filtro.dateStart"  (dateChange)="setPeriod(true,$event.value)"/>
                    <mat-datepicker-toggle matSuffix [for]="startDate"></mat-datepicker-toggle>
                    <mat-datepicker #startDate></mat-datepicker>
                </mat-form-field>
            </div>
        </div>
        <div class="col-lg-4 col-md-6 col-sm-12 my-4">
            <div class="custom-filter-input-container">
                <mat-form-field>
                    <input id="endDate" matInput [min]="filtro.dateStart" [max]="dataMaxima" [matDatepicker]="endDate" placeholder="Data Fim" [value]="filtro.dateEnd"  (dateChange)="setPeriod(false,$event.value)"/>
                    <mat-datepicker-toggle matSuffix [for]="endDate"></mat-datepicker-toggle>
                    <mat-datepicker #endDate></mat-datepicker>
                </mat-form-field>
            </div>
        </div>
        <div class="col-lg-4 col-md-6 col-sm-12 my-4">
            <div class="custom-filter-input-container">
                <mat-form-field>
                    <mat-label>Tipo de Pagamento</mat-label>
                    <mat-select [formControl]="paymentTypeCtrl" placeholder="Selecione...">
                        <mat-option>Ambos</mat-option>
                        <mat-option value="Boleto">Boleto</mat-option>
                        <mat-option value="Pix">PIX</mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
        </div>
        <div class="col-lg-4 col-md-6 col-sm-12 my-4">
            <div class="custom-filter-input-container">
                <mat-form-field>
                    <mat-label>Status</mat-label>
                    <mat-select [formControl]="statusCtrl" placeholder="Selecione...">
                        <mat-option>Nenhum</mat-option>
                        <mat-option value="Cancelado">Cancelado</mat-option>
                        <mat-option value="Concluido">Concluido</mat-option>
                        <mat-option value="Pendente">Pendente</mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
        </div>
        <div class="col-lg-4 col-md-6 col-sm-12 my-4">
            <div class="custom-filter-input-container">
                <mat-form-field>
                    <mat-label>Valor</mat-label>
                    <input [formControl]="valueCtrl" [textMask]="{mask: MASKS.currency.textMask}" matInput type="text" id="value">
                    <button mat-button *ngIf="filtroNome" matSuffix mat-icon-button aria-label="Clear" (click)="filtroNome=''">
                        <mat-icon>close</mat-icon>
                    </button>
                </mat-form-field>
            </div>
        </div>
        <div class="col-lg-4 col-md-6 col-sm-12 my-4">
            <mat-form-field>
                <mat-label>Código da Recarga</mat-label>
                <input [formControl]="purchaseCtrl" matInput type="number" id="purchase">
                <button mat-button *ngIf="filtroCPF" matSuffix mat-icon-button aria-label="Clear" (click)="filtroCPF=''">
                    <mat-icon>close</mat-icon>
                </button>
            </mat-form-field>
        </div>
        <!-- <div class="col-lg-4 col-md-6 col-sm-12 my-4">
            <div class="custom-filter-input-container">
                <mat-form-field>
                    <mat-select [formControl]="productsCtrl" id="produto" [multiple]="true" placeholder="Produtos" [value]="filtro.productsId">
                        <mat-option *ngFor="let item of assignorContractList" [value]="item.produtoElegibilidade.produto.produtoId">
                            {{item.produtoElegibilidade.produto.descricao}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
        </div>
        <div class="col-lg-4 col-md-6 col-sm-12 my-4 align-center">
            <div class="custom-filter-input-container">
                <mat-checkbox [formControl]="agroupCtrl" id="agrupar" [value]="filtro.groupByMonth" color="primary">Agrupar por mês</mat-checkbox>
            </div>
        </div>         -->
    </div>
    <div class="col-12 clean-modal-footer">
        <button class="custom-filter-button custom-filter-button-just" type="button" (click)="applyFilter();modal.dismiss('Close click')" ngbAutofocus>
            Aplicar
        </button>
    </div>
</ng-template>


<!-- Modal do recibo -->
<ng-template #visualizarRecibo let-modal>
    <div class="col-12 modal-header clean-modal-header">
        <div class="col-md-12">
            <h5 class="modal-title clean-modal-title">
                Recibo
            </h5>
            <p class="clean-modal-subtitle">
                Visualize abaixo os dados do seu recibo.
            </p>
        </div>
    </div>
    <div class="col-12 clean-modal-content">
        <div class="clean-modal-section-title">Comprovante de pagamento</div>
        <div class="clean-modal-text" *ngIf="reciboIntencaoDeposito.guidId">
            <span class="clean-modal-span">Código da transação:</span> {{ reciboIntencaoDeposito.guidId }}
        </div>
        <div class="clean-modal-text" *ngIf="reciboIntencaoDeposito.id">
            <span class="clean-modal-span">Pagamento:</span> {{ reciboIntencaoDeposito.id }}
        </div>
        <div class="clean-modal-text" *ngIf="reciboIntencaoDeposito.meioPagamento">
            <span class="clean-modal-span">Forma de Pagamento:</span> {{ reciboIntencaoDeposito.meioPagamento }}
        </div>
        <div class="clean-modal-text" *ngIf="reciboIntencaoDeposito.dataProcessamento">
            <span class="clean-modal-span">Data de Processamento:</span> {{ reciboIntencaoDeposito.dataProcessamento | date: "dd/MM/yyyy" }}
        </div>
        <div class="clean-modal-text" *ngIf="reciboIntencaoDeposito.valorPedido">
            <span class="clean-modal-span">Total pedido:</span> {{ reciboIntencaoDeposito.valorPedido | currency: "BRL":true }}
        </div>
        <div class="clean-modal-text" *ngIf="reciboIntencaoDeposito.valorPago">
            <span class="clean-modal-span">Total pago:</span> {{ reciboIntencaoDeposito.valorPago | currency: "BRL":true }}
        </div>
        <div *ngIf="reciboIntencaoDeposito.identificador" class="clean-modal-text">
            <span class="clean-modal-span">Identificador:</span> {{ reciboIntencaoDeposito.identificador }}
        </div>
        <hr *ngIf="reciboIntencaoDeposito.pagadorNomeJuridico || reciboIntencaoDeposito.pagadorNomeFantasia"/>
        <div class="clean-modal-section-title" *ngIf="reciboIntencaoDeposito.pagadorNomeJuridico || reciboIntencaoDeposito.pagadorNomeFantasia">Pagador</div>
        <div class="clean-modal-text" *ngIf="reciboIntencaoDeposito.pagadorNomeJuridico">
            <span class="clean-modal-span">Razão social:</span> {{ reciboIntencaoDeposito.pagadorNomeJuridico }}
        </div>
        <div class="clean-modal-text" *ngIf="reciboIntencaoDeposito.pagadorNomeFantasia">
            <span class="clean-modal-span">Nome fantasia:</span> {{ reciboIntencaoDeposito.pagadorNomeFantasia }}
        </div>
        <hr />
        <div class="clean-modal-section-title">Recebedor</div>
        <div class="clean-modal-text" *ngIf="reciboIntencaoDeposito.recebedor">
            <span class="clean-modal-span">Razão social:</span> {{ reciboIntencaoDeposito.recebedor }}
        </div>


    </div>

    <div class="col-12 clean-modal-footer">
        <button class="custom-filter-button button-cancel" type="button" (click)="modal.dismiss('Close click')">
        Fechar
        </button>
    </div>
</ng-template>